import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { seleccionarPagina } from "../../../features/ui/uiSlice";
import { ValidacionComponent } from "../../../components/ValidacionComponent";
import { Label } from "../../../components/ui/Label";
import { Input } from "../../../components/ui/Input";
import Button from "../../../components/ui/Button";
import { useCatCancelacionesQuery } from "../../../services/docs";
import { RetencionComponent } from "../../../components/RetencionComponent";
import { RootState } from "../../../store";
import { CancelacionComponent } from "../../../components/CancelacionComponent";

export const CancelacionScreen = () => {
  const [validacion, setValidacion] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(seleccionarPagina("p-cancelacion"));
  }, [0]);

  if (!validacion) {
    return (
      <ValidacionComponent
        inactivo={true}
        validacion={validacion}
        setValidacion={setValidacion}
      />
    );
  }
  return (
    <>
      <div className="w-full p-5">
        <div className="mt-2 grid grid-cols-1 gap-10 px-2 sm:grid-cols-2 lg:grid-cols-2">
          <RetencionComponent />
          <CancelacionComponent />
        </div>
      </div>
    </>
  );
};
